// @ts-ignore
import ColorThief from 'color-thief-browser';

const GetColor = (imageUrl: string): Promise<number[]> => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        const colorThief = new ColorThief();

        img.crossOrigin = 'anonymous';
        img.src = imageUrl ? `data:image/jpeg;base64,${imageUrl}` : `${process.env.PUBLIC_URL}/img/book_4.jpg`;

        const toPastel = (rgb: number[]): number[] => {
            return rgb.map(channel => Math.round((channel + 255) / 2));
        };

        const isAlmostWhite = (rgb: number[]): boolean => {
            const avg = rgb.reduce((a, b) => a + b, 0) / 3;
            return avg >= 245;
        };

        const fallbackColor =  [130, 130, 130];

        img.onload = () => {
            try {
                let color = colorThief.getColor(img);
                if (isAlmostWhite(color)) {
                    color = fallbackColor;
                }
                const pastelColor = toPastel(color);
                resolve(pastelColor);
            } catch (err) {
                reject(err);
            }
        };

        img.onerror = () => {
            reject(new Error(`이미지 로드 실패: ${imageUrl}`));
        };
    });
};

export default GetColor;
